import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { dateHelper } from '@cakeiteasy/web-utils';
import moment from 'moment';

@Injectable()
export class NgbDatepickerI18nService extends NgbDatepickerI18n {
  getWeekdayLabel(weekday: number): string {
    return dateHelper.getWeekDayName(weekday, 'ddd');
  }

  getMonthShortName(month: number): string {
    return dateHelper.getMonthName(month, 'MMM');
  }

  getMonthFullName(month: number): string {
    return dateHelper.getMonthName(month, 'MMMM');
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return moment().year(date.year).month(date.month - 1).day(date.day).format('DD.MM.YYYY');
  }
}
